import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add as AddIcon, Search as SearchIcon } from '@mui/icons-material';

/** Empty / no-results panel; pass `sx` with `flex: 1` / `minHeight` when used inside a flex layout. */
export const EmptyState = ({ type, onAddNew, sx }) => {
  const noResultsSx = [
    {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      minHeight: '100%',
      flex: 1,
      boxSizing: 'border-box',
      py: { xs: 4, sm: 6 },
      px: '24px',
    },
    ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
  ];

  if (type === 'no-results') {
    return (
      <Box sx={noResultsSx}>
        <Box
          sx={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            backgroundColor: '#F5F5F5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: '24px',
          }}
        >
          <SearchIcon sx={{ fontSize: 60, color: '#9E9E9E' }} />
        </Box>
        <Typography
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 600,
            fontSize: '20px',
            color: '#212121',
            mb: '8px',
          }}
        >
          No Results Found
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 400,
            fontSize: '14px',
            color: '#4A5565',
            textAlign: 'center',
            maxWidth: '400px',
          }}
        >
          We couldn't find any alert rules matching your search criteria. Try adjusting your filters or search terms.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          minHeight: '100%',
          flex: 1,
          boxSizing: 'border-box',
          py: { xs: 4, sm: 6 },
          px: '24px',
          overflowY: 'auto',
        },
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
    >
      {/* Illustration */}
      <Box
        sx={{
          width: '200px',
          height: '200px',
          mb: '24px',
          position: 'relative',
        }}
      >
        {/* Alert Bell Illustration */}
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="100" r="80" fill="#F5F5F5" />
          <path
            d="M100 40C85 40 73 52 73 67V85C73 90 70 95 66 98L62 102C60 104 60 107 62 109C64 111 66 112 69 112H131C134 112 136 111 138 109C140 107 140 104 138 102L134 98C130 95 127 90 127 85V67C127 52 115 40 100 40Z"
            fill="#2932E5"
          />
          <path
            d="M95 120C95 117.239 97.2386 115 100 115C102.761 115 105 117.239 105 120V125C105 127.761 102.761 130 100 130C97.2386 130 95 127.761 95 125V120Z"
            fill="#2932E5"
          />
          <circle cx="120" cy="60" r="15" fill="#FF8555" />
          <path
            d="M115 60L118 63L125 56"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Box>

      <Typography
        sx={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 600,
          fontSize: '24px',
          color: '#212121',
          mb: '8px',
        }}
      >
        No Alert Rules Yet
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 400,
          fontSize: '14px',
          color: '#4A5565',
          textAlign: 'center',
          maxWidth: '400px',
          mb: '24px',
        }}
      >
        Get started by creating your first alert rule to monitor your cameras, IoT devices, or system events.
      </Typography>
      {onAddNew && (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddNew}
          sx={{
            backgroundColor: '#2932E5',
            borderRadius: '10px',
            textTransform: 'none',
            px: '24px',
            py: '12px',
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 500,
            fontSize: '14px',
            color: 'white',
            boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
            '&:hover': {
              backgroundColor: '#1f28c7',
            },
          }}
        >
          New Rule
        </Button>
      )}
    </Box>
  );
};